import React, { useState } from "react";
import { Link, useNavigate } from 'react-router-dom';
import logo from '../../images/logo.png';
import { useDispatch } from "react-redux";
import { toast } from 'react-toastify';
import { loginUser } from '../../Api/authApi.js.js';
import { login } from "../../redux/authSlice.js";
import { ROLE_PROFESSOR } from "../../constants/roles";

const inputStyle = {
    width: '100%', background: 'rgba(255,255,255,0.05)',
    border: '1px solid rgba(255,255,255,0.08)',
    borderRadius: 14, color: '#F2F5FB', fontSize: 15,
    padding: '14px 44px 14px 42px', outline: 'none',
    boxSizing: 'border-box',
};

const LoginPage = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const [LoginData, setLoginData] = useState({ email: '', password: '' });
    const [showPassword, setShowPassword] = useState(false);

    const handleChange = (e) => {
        setLoginData({ ...LoginData, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const response = await loginUser(LoginData, dispatch);
            if (response && response.message) {
                toast.success(response.message);
                setLoginData({ email: '', password: '' });
                if (response.data?.role === ROLE_PROFESSOR) {
                    navigate('/espace-professeur/vue-ensemble');
                } else {
                    navigate('/accueil');
                }
            } else {
                throw new Error('Réponse invalide du serveur');
            }
        } catch (error) {
            const errorMessage = error.response?.data?.message ?? 'Une erreur est survenue';
            toast.warning(errorMessage);
        }
    };

    return (
        <div style={{
            minHeight: '100vh', background: '#0A1226',
            display: 'flex', flexDirection: 'column',
            alignItems: 'center', justifyContent: 'center',
            padding: '32px 24px',
            WebkitFontSmoothing: 'antialiased',
            position: 'relative',
        }}>
            {/* Bouton retour */}
            <div style={{ position: 'absolute', top: 20, left: 20 }}>
                <Link to="/" style={{ textDecoration: 'none' }}>
                    <button style={{
                        width: 38, height: 38, borderRadius: 12,
                        background: 'rgba(255,255,255,0.06)',
                        border: '1px solid rgba(255,255,255,0.08)',
                        display: 'grid', placeItems: 'center',
                        cursor: 'pointer', color: '#F2F5FB', padding: 0,
                    }}>
                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                            <path d="M10 3L5 8l5 5" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                    </button>
                </Link>
            </div>

            <div style={{ width: '100%', maxWidth: 360 }}>
                {/* Logo */}
                <div style={{ display: 'flex', justifyContent: 'center', marginBottom: 36 }}>
                    <img src={logo} alt="Trading Series" style={{ height: 48, width: 'auto' }} />
                </div>

                <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
                    {/* Email */}
                    <div style={{ position: 'relative' }}>
                        <span style={{ position: 'absolute', left: 14, top: '50%', transform: 'translateY(-50%)', color: '#5C6B88', display: 'flex' }}>
                            <svg width="16" height="16" viewBox="0 0 20 16" fill="currentColor">
                                <path d="m10.036 8.278 9.258-7.79A1.979 1.979 0 0 0 18 0H2A1.987 1.987 0 0 0 .641.541l9.395 7.737Z"/>
                                <path d="M11.241 9.817c-.36.275-.801.425-1.255.427-.428 0-.845-.138-1.187-.395L0 2.6V14a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V2.5l-8.759 7.317Z"/>
                            </svg>
                        </span>
                        <input
                            type="email" name="email" value={LoginData.email}
                            onChange={handleChange} placeholder="Adresse e-mail"
                            required style={inputStyle}
                        />
                    </div>

                    {/* Mot de passe */}
                    <div style={{ position: 'relative' }}>
                        <span style={{ position: 'absolute', left: 14, top: '50%', transform: 'translateY(-50%)', color: '#5C6B88', display: 'flex' }}>
                            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                <rect x="3" y="11" width="18" height="11" rx="2" ry="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/>
                            </svg>
                        </span>
                        <input
                            type={showPassword ? 'text' : 'password'}
                            name="password" value={LoginData.password}
                            onChange={handleChange} placeholder="Mot de passe"
                            required style={inputStyle}
                        />
                        <button type="button" onClick={() => setShowPassword(v => !v)} style={{
                            position: 'absolute', right: 14, top: '50%', transform: 'translateY(-50%)',
                            background: 'none', border: 'none', cursor: 'pointer', color: '#5C6B88', padding: 0, display: 'flex',
                        }}>
                            {showPassword ? (
                                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                    <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"/>
                                    <line x1="1" y1="1" x2="23" y2="23"/>
                                </svg>
                            ) : (
                                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                    <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/>
                                </svg>
                            )}
                        </button>
                    </div>

                    {/* Mot de passe oublié */}
                    <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                        <Link to="/mot-de-passe-oublie" style={{ textDecoration: 'none' }}>
                            <span style={{ fontSize: 13, color: '#97A4BE', fontWeight: 500 }}>Mot de passe oublié ?</span>
                        </Link>
                    </div>

                    <button type="submit" style={{
                        marginTop: 4, height: 54, borderRadius: 16, width: '100%',
                        background: 'linear-gradient(180deg, #ffffff 0%, #e3e8f1 100%)',
                        color: '#0A1226', border: 'none', cursor: 'pointer',
                        fontWeight: 700, fontSize: 15,
                        display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 9,
                        boxShadow: 'inset 0 1px 0 rgba(255,255,255,0.9), 0 10px 24px -10px rgba(0,0,0,0.6)',
                    }}>
                        S'identifier
                    </button>
                </form>

                <p style={{ textAlign: 'center', marginTop: 24, fontSize: 14, color: '#5C6B88' }}>
                    Pas encore de compte ?{' '}
                    <Link to="/inscription" style={{ color: '#97A4BE', fontWeight: 600, textDecoration: 'none' }}>
                        S'inscrire
                    </Link>
                </p>
            </div>
        </div>
    );
};

export default LoginPage;
